import { render, staticRenderFns } from "./RelativeProfileForm.vue?vue&type=template&id=2222a3c8&scoped=true&"
import script from "./RelativeProfileForm.vue?vue&type=script&lang=ts&"
export * from "./RelativeProfileForm.vue?vue&type=script&lang=ts&"
import style0 from "./RelativeProfileForm.vue?vue&type=style&index=0&id=2222a3c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2222a3c8",
  null
  
)

export default component.exports